import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "EnrolmentMenu" }
const _hoisted_2 = { class: "EnrolmentActionsWrapper" }
const _hoisted_3 = {
  key: 0,
  class: "CannotExportExplanationContainer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnrolmentsTableFilter = _resolveComponent("EnrolmentsTableFilter")!
  const _component_SearchEnrolmentsBar = _resolveComponent("SearchEnrolmentsBar")!
  const _component_ColumnSavingButtons = _resolveComponent("ColumnSavingButtons")!
  const _component_ContractDetailsButton = _resolveComponent("ContractDetailsButton")!
  const _component_InternalEnrolmentsExport = _resolveComponent("InternalEnrolmentsExport")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_EnrolmentsTableFilter),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SearchEnrolmentsBar),
      _createVNode(_component_ColumnSavingButtons),
      (!_ctx.buttonsEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
            _createElementVNode("span", null, "To export enrolments or view contract details, select a university.", -1 /* CACHED */)
          ])))
        : _createCommentVNode("v-if", true),
      (_openBlock(), _createBlock(_component_ContractDetailsButton, {
        key: _ctx.buttonsEnabled,
        canOpen: _ctx.buttonsEnabled
      }, null, 8 /* PROPS */, ["canOpen"])),
      (_openBlock(), _createBlock(_component_InternalEnrolmentsExport, {
        key: _ctx.buttonsEnabled,
        canExport: _ctx.buttonsEnabled
      }, null, 8 /* PROPS */, ["canExport"]))
    ])
  ]))
}